import { Layout } from 'antd'
import React from 'react'
import Header from '../components/Authorized/Header'
import ViewJobDetail from '../components/Utilities/ViewJobDetail'

const JobDetailPage = (props) => {
    return (
        <Layout>
            <Header />
            <Layout.Content>
                <ViewJobDetail jobId={props.match.params.jobId} />
            </Layout.Content>
        </Layout>
    )
}

export default JobDetailPage
